import { useFinanceReceiverStore } from "@/modules/financeReceiver/store";

export default async function redirectToOnboardingIfRequired() {
  const financeReceiverStore = useFinanceReceiverStore();
  await financeReceiverStore.fetchFinanceReceiver();
  if (financeReceiverStore.isOnboarding) {
    return { name: "onboarding" };
  }
  return undefined;
}
